import React from "react";

import {
  Icon,
  Label,
  HiddenCheckbox,
  StyledCheckbox,
  CheckboxContainer,
  Description,
  Content,
  Title
} from "./checkbox/CheckboxStyle";

export const Checkbox = ({ checked, children, description, ...props }) => (
  <CheckboxContainer>
    <Label checked={checked}>
      <HiddenCheckbox checked={checked} {...props} />
      <Content>
        <StyledCheckbox className="StyledCheckbox" checked={checked}>
          <Icon viewBox="0 0 24 24">
            <polyline points="20 6 9 17 4 12" />
          </Icon>
        </StyledCheckbox>
        <Title>{children}</Title>
      </Content>
      {description && <Description>{description}</Description>}
    </Label>
  </CheckboxContainer>
);



// WEBPACK FOOTER //
// ./src/newDropshipperApp/spocketUI/components/Checkbox.js